var map = {
	"./a_symbol.png": 64162,
	"./advanced.png": 35499,
	"./arbitrum.png": 52835,
	"./avalanche.png": 92829,
	"./avalanche1.png": 7168,
	"./avax.png": 85167,
	"./back_icon.png": 77888,
	"./ban1.png": 59755,
	"./ban2.png": 52668,
	"./banner_img.png": 15758,
	"./base.png": 29077,
	"./beginners.png": 49102,
	"./blog_01.png": 73698,
	"./blog_02.jpg": 95763,
	"./blog_03.jpg": 29976,
	"./blog_04.jpg": 99281,
	"./book_icon.png": 10124,
	"./bridge_bg.png": 42176,
	"./bsc_wallet.png": 15686,
	"./button_default.png": 85970,
	"./button_selected.png": 98202,
	"./caret_icon.png": 14149,
	"./chart.png": 64772,
	"./chart_exchange_icon.png": 47180,
	"./close_icon.png": 82790,
	"./confetti.png": 18399,
	"./confirm_loader.gif": 82804,
	"./confirm_loader.svg": 79751,
	"./copy_icon.png": 77797,
	"./crypto/ada.png": 18937,
	"./crypto/alpa.png": 1172,
	"./crypto/ape.png": 48732,
	"./crypto/arbitrum.png": 68261,
	"./crypto/arbitrum.svg": 60641,
	"./crypto/atom.png": 9820,
	"./crypto/avalanche.png": 58598,
	"./crypto/avalanche.svg": 7203,
	"./crypto/balbt.png": 18097,
	"./crypto/base.png": 79577,
	"./crypto/base.svg": 56618,
	"./crypto/bch.png": 14837,
	"./crypto/bnb.png": 17511,
	"./crypto/bsc.png": 50476,
	"./crypto/bsc.svg": 69223,
	"./crypto/busd.png": 13195,
	"./crypto/cake.png": 96958,
	"./crypto/cream.png": 41142,
	"./crypto/doge.png": 48163,
	"./crypto/eth.png": 8388,
	"./crypto/eth.svg": 79151,
	"./crypto/fantom.png": 97210,
	"./crypto/fantom.svg": 14213,
	"./crypto/heco.png": 82040,
	"./crypto/optimism.png": 89071,
	"./crypto/optimism.svg": 96018,
	"./crypto/polygon.png": 49879,
	"./crypto/polygon.svg": 57438,
	"./crypto/usdc.png": 79693,
	"./discord.png": 78288,
	"./dot_01.png": 8182,
	"./eth.png": 52762,
	"./exchange.png": 18901,
	"./fantom.png": 43984,
	"./fantom1.png": 7459,
	"./flags/america.png": 39586,
	"./flags/bangladesh.png": 34143,
	"./flags/brazil.png": 15946,
	"./flags/china.png": 38682,
	"./flags/finland.png": 6496,
	"./flags/france.png": 29883,
	"./flags/germany.png": 48239,
	"./flags/greece.png": 71919,
	"./flags/hungary.png": 63780,
	"./flags/india.png": 25829,
	"./flags/indonesia.png": 67262,
	"./flags/italy.png": 48827,
	"./flags/japan.png": 94352,
	"./flags/korea.png": 18108,
	"./flags/netherlands.png": 97093,
	"./flags/philippines.png": 37971,
	"./flags/poland.png": 63758,
	"./flags/portugal.png": 74382,
	"./flags/romania.png": 70357,
	"./flags/russia.png": 38217,
	"./flags/saudi_arabia.png": 82639,
	"./flags/spain.png": 11492,
	"./flags/sweden.png": 66960,
	"./flags/turkey.png": 1383,
	"./flags/ukraine.png": 2125,
	"./flags/vietnam.png": 37344,
	"./footer_logo.png": 86992,
	"./footer_logo.svg": 64528,
	"./fusion.png": 74366,
	"./gas-station.png": 81406,
	"./gift.png": 5330,
	"./github.png": 94343,
	"./heco.png": 53483,
	"./hodlcard_img.png": 60016,
	"./ice_cream.png": 54166,
	"./icon_01.png": 10405,
	"./icon_02.png": 65320,
	"./img_01.png": 91627,
	"./img_02.png": 38993,
	"./img_022.png": 39227,
	"./info_icon.png": 24348,
	"./instagram.png": 58935,
	"./limit.png": 64815,
	"./loader.gif": 31298,
	"./lock_icon.png": 20587,
	"./logo.png": 74427,
	"./logo.svg": 82835,
	"./megaswap.png": 41938,
	"./menu_arrow.png": 20181,
	"./menu_arrow1.png": 82124,
	"./metamask.png": 58843,
	"./mobile_img_01.png": 37886,
	"./mobile_img_011.png": 29005,
	"./mobile_img_02.png": 68628,
	"./mobile_img_022.png": 57983,
	"./mobile_img_03.png": 33040,
	"./mobile_img_033.png": 80553,
	"./multiple_icon.png": 99773,
	"./network_01.png": 57324,
	"./network_02.png": 2807,
	"./network_03.png": 43407,
	"./network_04.png": 50447,
	"./network_05.png": 34841,
	"./network_06.png": 99967,
	"./network_07.png": 31111,
	"./network_08.png": 60106,
	"./newwindow.png": 12286,
	"./no_orders_icon.png": 99259,
	"./not_found.png": 90130,
	"./optimism.png": 21966,
	"./p2p.png": 79351,
	"./plus.png": 97477,
	"./ref.png": 13583,
	"./refresh_icon.png": 80685,
	"./right.png": 9602,
	"./rotate_icon_01.png": 50627,
	"./rotate_icon_02.png": 38755,
	"./rotate_icon_03.png": 11544,
	"./rotate_icon_04.png": 41711,
	"./rotate_icon_center.png": 14984,
	"./routing_from.png": 48108,
	"./routing_to.png": 96274,
	"./search_bg.png": 85564,
	"./search_icon.png": 49819,
	"./search_icon_white.png": 35353,
	"./search_white.png": 9811,
	"./select_icon.png": 81694,
	"./settings_icon.png": 7284,
	"./simple_icon.png": 86630,
	"./simpleswap.png": 22711,
	"./swap_icon.png": 50215,
	"./switch_icon.png": 87202,
	"./technical.png": 36117,
	"./transfer.png": 29741,
	"./triangle.png": 79781,
	"./twitter.png": 46737,
	"./unlock.png": 29885,
	"./unlocked.png": 19078,
	"./wallet_connect.png": 58819,
	"./wallet_icon.png": 39073,
	"./water.png": 51124
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 90990;